import React from 'react'

const Footer = () => {
  return (
    <>
        <div className='py-4 bg-secondary text-center text-white'>&copy; raja jenickson portfolio 2025.  All rights reserved.</div>
    </>
  )
}

export default Footer